var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-layout',{attrs:{"file-name":_vm.fileName,"show-header":_vm.isPublic,"can-download":_vm.isPublic,"allow-share":false},on:{"download":_vm.onDownload}},[_c('div',{staticClass:"viewbox"},[(_vm.link)?_c('audio',{attrs:{"autoplay":"autoplay","controls":"controls"}},[_c('source',{attrs:{"src":_vm.link}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }